// All over the file changes has been done by Dev srini on 07/08/24

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider'
import { DatePicker } from '@mui/x-date-pickers/DatePicker'
import { withStyles } from '@material-ui/core/styles'
import { Checkbox, FormControlLabel, Button } from '@material-ui/core'
import { MenuItem, TextField, Grid, FormControl, InputLabel, Select } from '@mui/material' //dev-trupti on 26-12-2024

import styles from '../InCompleteKYCStyles'

const DateFields = ({
    classes, kycFdate, kycTdate, handleKycFDate, handleKycTDate, kycClient, handleKycClient , selectPlan, handlePlans 
    // checkboxToggle, handlecheckboxChange, status, setStatus,hide, setHide //dev-trupti on 24-12-2024
}) => {


    const textFieldStyles = {
        marginLeft:'10px !important',
        width:'150px !important',
        '& .MuiInputBase-root': {
                            backgroundColor: '#131E2E !important',
                            color: 'white !important', 
                            fontFamily: 'cardiuma-regular', 
                            fontSize:'15px'
                        },
                        '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: '131E2E !important',
                        },
                        '& .MuiInputLabel-root': {
                            color: 'white !important',
                            fontFamily: 'cardiuma-regular',
                            fontSize: '14px', 
                        },
                        '& .MuiInputBase-input': {
                            color: 'white !important',
                        },
    }


    return (
        <div style={{ margin: '0% 0 0% 0%' }}>
            <form className={classes.kycFormDateField}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <span >
                        <DatePicker
                            label="From"
                            format="DD-MM-YYYY"
                            variant="outlined"
                            InputLabelProps={{ shrink: true }}
                            InputProps={{ className: classes.input }}
                            className={classes.datePicker}
                            value={kycFdate}
                            onChange={(newValue) => { handleKycFDate(newValue) }}
                        />
                    </span>
                    <span 
                    className={classes.datePickerWrapper}
                    >
                        <DatePicker
                            label="To"
                            format="DD-MM-YYYY"
                            variant="outlined"
                            InputLabelProps={{ shrink: true }}
                            InputProps={{ className: classes.input }}
                            className={classes.datePicker}
                            value={kycTdate}
                            onChange={(newValue) => { handleKycTDate(newValue) }}
                        />
                    </span>
                         <TextField
                            label="Client Code"
                            variant="outlined"
                            value={kycClient}
                            onChange={handleKycClient}
                            size='small'
                            sx={{...textFieldStyles}}
                            /> 
                            {/* added plans dropdown START by kartik - 10-01-2025 */}
                    {/* <Grid style={{ marginLeft: "10px", borderRadius: "5px" }}>
                        <FormControl size="small" style={{ width: "100%" }}>
                            <InputLabel className={classes.inputColor} id="demo-select-small-label">
                                Plans
                            </InputLabel>
                            <Select
                                className={classes.select}
                                labelId="demo-select-small-label"
                                id="demo-select-small"
                                value={selectPlan}
                                label="Select"
                                onChange={(newValue) => { handlePlans(newValue) }}
                                displayEmpty
                                MenuProps={{
                                    PaperProps: {
                                        style: {
                                            top: '50px'
                                        },
                                    },
                                }}
                                sx={{
                                    height: '40px',
                                    ".css-hfutr2-MuiSvgIcon-root-MuiSelect-icon": {
                                        color: "white !important"
                                    },
                                    ".css-bpeome-MuiSvgIcon-root-MuiSelect-icon":{
                                        color: "white !important"
                                    }
                                }}
                            >
                                <MenuItem className={classes.intSelText} value="Subscription">
                                    Subscription
                                </MenuItem>
                              
                                 <MenuItem className={classes.intSelText} value="Zero brokerage">
                                    Zero Brokerage
                                </MenuItem>
                                <MenuItem className={classes.intSelText} value="Zero brokerage Year">
                                    Zero Brokerage Year
                                </MenuItem>
                            </Select>
                        </FormControl>
                    </Grid> */}
                    {/* added plans dropdown END by kartik - 10-01-2025 */}
                    {/* commented the code  and added client code by dev-trupti on 24-12-2024 */}
                    {/* <span className={classes.checkBox}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={checkboxToggle === "completed"}
                                    onChange={(e) => {//dev-trupti on 26-11-2024
                                        setHide(false)
                                        handlecheckboxChange(e, "completed")}}
                                />
                            }
                            label="Completed"
                        />

                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={checkboxToggle === "incompleted"}
                                    onChange={(e) => {//dev-trupti on 26-11-2024
                                        setHide(true)
                                        setStatus(false)
                                        handlecheckboxChange(e, "incompleted")}}
                                />
                            }
                            label="Incomplete"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={checkboxToggle === "pending"}
                                    onChange={(e) => {//dev-trupti on 26-11-2024
                                        setHide(false)
                                        handlecheckboxChange(e, "pending")
                                    }}
                                />
                            }
                            label="Bank Pending"
                        />
                        {hide && <FormControlLabel
                            control={
                                <Checkbox
                                checked={status === true}
                                onChange={(e) =>{
                                    if(e.target.checked){
                                        setStatus(e.target.checked)
                                        handlecheckboxChange(e, "incompleted","INACTIVE")
                                    }else{
                                        setStatus(e.target.checked)
                                        handlecheckboxChange(e, "incompleted","ACTIVE")
                                    }}}
                                />
                            }
                            label="Archieved"
                        />}
                    </span> */}

                    
                </LocalizationProvider>
            </form>
        </div>
    )
}

export default withStyles(styles)(DateFields)
